import { render, staticRenderFns } from "./ParcelaData.vue?vue&type=template&id=0a1f64d2&scoped=true"
import script from "./ParcelaData.vue?vue&type=script&lang=js"
export * from "./ParcelaData.vue?vue&type=script&lang=js"
import style0 from "./ParcelaData.vue?vue&type=style&index=0&id=0a1f64d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f64d2",
  null
  
)

export default component.exports